import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SCRIPT_ID } from './config';
import { getCurrentScript } from './lib/DOM/Script';
import { isMocks, setupMocks } from './mocks/utils/setupBrowser';

type CurrentScriptType = HTMLElement | SVGScriptElement | null;

async function createRoot(currentScript: CurrentScriptType) {
	if (isMocks(currentScript)) {
		await setupMocks(currentScript);
	}

	const rootId = `${SCRIPT_ID}-root`;
	const div = document.createElement('div');

	div.setAttribute('id', rootId);

	document.body.insertBefore(div, document.body.firstChild);

	return ReactDOM.createRoot(document.getElementById(rootId) as HTMLElement);
}

async function index() {
	const currentScript = getCurrentScript();
	const root = await createRoot(currentScript);

	root.render(
		<React.StrictMode>
			<App currentScript={currentScript} />
		</React.StrictMode>
	);

	// If you want to start measuring performance in your app, pass a function
	// to log results (for example: reportWebVitals(console.log))
	// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
	reportWebVitals();
}

index();
